import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FilterLabelStore {
  private readonly store = signal<Record<string, Record<string, string>>>({});
  private readonly subStore = signal<Record<string, Record<string, string>>>({});

  set(
    filterKey: string,
    entries: { value: string; label: string; subLabel?: string }[],
  ): void {
    if (entries.length === 0) return;
    this.store.update((s) => {
      const existing = s[filterKey] ?? {};
      const next: Record<string, string> = { ...existing };
      for (const e of entries) next[e.value] = e.label;
      return { ...s, [filterKey]: next };
    });
    const subEntries = entries.filter(
      (e): e is { value: string; label: string; subLabel: string } =>
        typeof e.subLabel === 'string' && e.subLabel.length > 0,
    );
    if (subEntries.length === 0) return;
    this.subStore.update((s) => {
      const existing = s[filterKey] ?? {};
      const next: Record<string, string> = { ...existing };
      for (const e of subEntries) next[e.value] = e.subLabel;
      return { ...s, [filterKey]: next };
    });
  }

  resolve(filterKey: string, value: string): string | null {
    return this.store()[filterKey]?.[value] ?? null;
  }

  clear(): void {
    this.store.set({});
    this.subStore.set({});
  }

  readonly snapshot = computed(() => this.store());

  readonly subLabelSnapshot = computed(() => this.subStore());
}
